// extracted by mini-css-extract-plugin
module.exports = {"sendIcon":"SubmitButton_sendIcon__1e3Zl","toolTip":"SubmitButton_toolTip__1TNfu"};